import { CONTENT_TYPE } from '../../constants';
import {
  SHOT_BACKGROUND_TYPES,
  VALID_SHOT_BACKGROUND_TYPES,
} from '../../features/video-reformatting/constants';

export default class ShotBackground {
  _type;
  _value;

  constructor(type, value) {
    this._type = type;
    this._value = value;
  }

  get type() {
    return this._type;
  }

  set type(value) {
    this._type = value;
  }

  get value() {
    return this._value;
  }

  set value(value) {
    this._value = value;
  }

  copy() {
    return new ShotBackground(this._type, this._value);
  }

  equals(anotherShotBackground) {
    return (
      ShotBackground.isShotBackground(anotherShotBackground) &&
      anotherShotBackground.type === this.type &&
      anotherShotBackground.value === this.value
    );
  }

  /**
   * Checks if object is an instance of ShotGroupMeta
   *
   * @param inputObject
   * @returns {boolean}
   */
  static isShotBackground(inputObject) {
    return inputObject instanceof ShotBackground;
  }

  static isValidShotBackground(inputObject) {
    return (
      ShotBackground.isShotBackground(inputObject) &&
      VALID_SHOT_BACKGROUND_TYPES.has(inputObject.type)
    );
  }

  static getShotBackgroundType(contentType) {
    return contentType === CONTENT_TYPE.SHAPE
      ? SHOT_BACKGROUND_TYPES.FILL
      : SHOT_BACKGROUND_TYPES.BLUR;
  }
}
